import OrderForwardListRequest, {
  OrderForwardListQueryParams,
} from "./order-forward-list.request";

const createQueryParams = (
  request: OrderForwardListRequest,
): OrderForwardListQueryParams => {
  return {
    address: request.address,
    consumer: request.consumer,
    driver: request.driver,
    endAddress: request.endAddress,
    externalId: request.externalId,
    humanId: request.humanId,
    limit: request.limit,
    midAddress: request.midAddress,
    offset: request.offset,
    order: request.order,
    passenger: request.passenger,
    producer: request.producer,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
  };
};

const orderForwardListRequestFactory = {
  createQueryParams,
};

export default orderForwardListRequestFactory;
